import { ActionWidget, SPI, Subscription, Widget, subscribeRoute, CallChaining } from '@kunlun/dependencies';
import Comp from './FormDraft.vue';
import { OioMessage } from '@kunlun/vue-ui-antd';
import { Draft } from './services';
import { useDraft } from './useDraft';
import { generateRandomNumber } from '../../field/form/MindMap/utils';

@SPI.ClassFactory(
  ActionWidget.Token({
    name: ['FormDraftAction', 'DeliAriesPlatformPromotionPlan']
  })
)
export class FormDraftAction extends ActionWidget {
  static DRAFT_KEY = 'NBDL_DMS_FORM_DRAFT';

  @Widget.Reactive()
  private hasDraft = false;

  @Widget.Reactive()
  private saveLoading = false;

  @Widget.Reactive()
  private backLoading = false;

  private draft!: Draft;

  private autoSaveInterval;

  private routeSubscription!: Subscription;

  private get isPlatform() {
    return this.model.moduleName.toLowerCase().includes('platform');
  }

  @Widget.Reactive()
  get invisible(): boolean {
    const includeViewActionModels = [
      'deli.platform.promotion.DeliAriesPlatformPromotionPlan',
      'deli.aries.seller.DeliAriesSellerPromotionPlan'
    ];
    const displayName = '创建';
    const resViewType = 'FORM';
    return (
      super.invisible ||
      !(
        includeViewActionModels.includes(this.viewAction?.model ?? '') &&
        (displayName === this.viewAction?.displayName ?? '') &&
        (resViewType === this.viewAction?.resViewType ?? '')
      )
    );

    // const includeViewActionNames = [
    //   'uiView0f223360de0f428dac63c850c8408fb9',
    //   'uiView51351e37b3844d8da461eeb2327a5545',
    //   'uiViewc5b401a9b57e498facdf9d794cb107bd'
    // ];

    // return super.invisible || !includeViewActionNames.includes(this.viewAction?.name ?? '');
  }

  @Widget.Reactive()
  @Widget.Inject()
  protected mountedCallChaining: CallChaining | undefined;

  public initialize(config) {
    super.initialize(config);
    this.setComponent(Comp);
    return this;
  }

  protected mounted() {
    super.mounted();
    if (this.mountedCallChaining) {
      this.mountedCallChaining.hook(this.path, async () => {
        await this.mountedProcess();
      });
    } else {
      this.mountedProcess();
    }
  }

  protected mountedProcess(): void {
    if (!this.invisible) {
      this.routeSubscription = subscribeRoute(
        (url) => {
          const currentPage = url.segmentParams.page || {};
          const { viewType, model } = currentPage;
          if (model === this.viewAction?.model && viewType === this.viewAction?.resViewType) {
            this.startAutoSave();
          } else if (this.autoSaveInterval) {
            clearInterval(this.autoSaveInterval);
          }
        },
        {
          distinct: true
        }
      );
    }
  }

  protected $$unmounted(): void {
    super.$$unmounted();
    this.routeSubscription?.unsubscribe();
  }

  private startAutoSave() {
    const time = 1000 * 60 * 3;

    this.autoSaveInterval = setInterval(() => {
      this.saveFormData();
    }, time);
  }

  @Widget.Method()
  private saveFormData() {
    window.postMessage('M2MTableDraftSaveData');
    this.saveLoading = true;

    setTimeout(async () => {
      try {
        let { saveDraft } = useDraft(this.rootRuntimeContext.view.name!);
        let params: Draft = {
          content: JSON.stringify(JSON.stringify(this.activeRecords![0]))
        };
        if (this.draft) {
          params.id = this.draft.id;
        }
        await saveDraft(params, this.isPlatform);

        // sessionStorage.setItem(FormDraftAction.DRAFT_KEY, JSON.stringify(this.activeRecords![0]));
        OioMessage.success('保存成功');
        this.hasDraft = true;
      } catch (error) {
        console.error(error);
      } finally {
        this.saveLoading = false;
      }
    }, 500);
  }

  @Widget.Method()
  private async backFormData() {
    // const draft = JSON.parse(sessionStorage.getItem(FormDraftAction.DRAFT_KEY)!);
    try {
      this.backLoading = true;
      const { getDrafts } = useDraft(this.rootRuntimeContext.view.name!);
      const res = await getDrafts(this.isPlatform);
      if (res.content) {
        const data = JSON.parse(res.content);
        // TODO:编辑时无需替换
        if (data.promotionDesignJson) {
          data.promotionDesignJson = this.repalceTreeId(data.promotionDesignJson);
        }
        this.activeRecords![0] = data;
        this.draft = res;

        window.postMessage('M2MTableDraftFillData');
        OioMessage.success('还原成功');
      } else {
        OioMessage.success('未发现任何草稿');
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.backLoading = false;
    }
  }

  private repalceTreeId(data: string) {
    const replacedIds: Record<string, string> = this.collectIds(JSON.parse(data));
    let str = data;
    for (const oldId in replacedIds) {
      const newId = replacedIds[oldId];
      str = str.replaceAll(oldId, newId);
    }
    return str;
  }

  private collectIds(data, res: Record<string, string> = {}) {
    if (!res[data.id]) {
      res[data.id] = generateRandomNumber();
    }
    if (data.parentId && !res[data.parentId]) {
      res[data.parentId] = generateRandomNumber();
    }
    if (data.children.length > 0) {
      for (const child of data.children) {
        this.collectIds(child, res);
      }
    }

    return res;
  }
}
